var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('book-chart-ponds'),_c('book-chart-farms'),_c('book-chart-disease')],1)}
var staticRenderFns = []

export { render, staticRenderFns }